/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import type { RefinementType } from '@/types/filterTypes';

export const getSelectedRefinementLabels = (refinements: RefinementType[]): string | null => {
  const selectedLabels = refinements
    .filter((r) => r.properties?.isSelected === 'true' || r.properties?.isSelected === true)
    .map((r) => r.label);

  return selectedLabels.length > 0 ? selectedLabels.join(', ') : null;
};
